import { useQueryWithAuth } from '@lib/Auth/clerk-utils'
import { stories } from '../model/query-keys'

export function useStories() {
  return useQueryWithAuth({
    ...stories.all(),
    select(data) {
      return data.stories.map((item) => ({
        ...item,
        id: item.id,
        title: item.title || '',
        body: item.body || '',
        published_date: item.published_date || '',
        hero_image_path: item.hero_image_path || '',
      }))
    },
  })
}
